var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5983 5.32476C11.2679 4.99432 10.7321 4.99432 10.4017 5.32476L5.01679 10.7096C4.68635 11.0401 4.68635 11.5758 5.01679 11.9063C5.34723 12.2367 5.88299 12.2367 6.21343 11.9063L11 7.11972L15.7866 11.9063C16.117 12.2367 16.6528 12.2367 16.9832 11.9063C17.3137 11.5758 17.3137 11.0401 16.9832 10.7096L11.5983 5.32476ZM10.1538 14.3846C10.1538 14.8519 10.5327 15.2308 11 15.2308C11.4673 15.2308 11.8462 14.8519 11.8462 14.3846H10.1538ZM11 5.92308H10.1538V14.3846H11H11.8462V5.92308H11Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/ArrowUp.b5c845f3a938f957ea6782f5e495726c.svg";
export { ForwardRef as ReactComponent };